module.exports = __webpack_public_path__ + "static/media/H2Q_Logo.23cd9ae3.png";